import IconButton from '@mui/material/IconButton';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import _ from 'lodash';
import clsx from 'clsx';
import type { IconButtonProps } from '@mui/material/IconButton';
import useFuseLayoutSettings from '@fuse/core/FuseLayout/useFuseLayoutSettings';
import useFuseSettings from '@fuse/core/FuseSettings/hooks/useFuseSettings';
import { navbarToggle, selectFuseNavbar } from './navbarSlice';
import LucideIcon from '@/components/common/LucideIcon';
import { ArrowLeftToLine, ArrowRightToLine } from 'lucide-react';

export type NavbarToggleButtonProps = IconButtonProps;

function NavbarToggleButton(props: NavbarToggleButtonProps) {
	const { className = '', children, ...rest } = props;

	const dispatch = useAppDispatch();
	const { config } = useFuseLayoutSettings();
	const { setSettings } = useFuseSettings();
	const navbarState = useAppSelector(selectFuseNavbar);

	const isOpen = config?.navbar?.style === 'style-2' ? !config?.navbar?.folded : navbarState.open;
	const icon = isOpen ? ArrowLeftToLine : ArrowRightToLine;

	return (
		<IconButton
			onClick={() => {
				if (config?.navbar?.style === 'style-2') {
					setSettings(_.set({}, 'layout.config.navbar.folded', !config?.navbar?.folded));
				} else {
					dispatch(navbarToggle());
				}
			}}
			{...rest}
			className={clsx(className)}
			sx={{
				backgroundColor: 'var(--neutral-base-white)',
				border: '1px solid var(--neutral-outline)',
				borderRadius: '8px',
				width: '32px',
				height: '32px',
				color: 'var(--neutral-gray-dark)',
				'&:hover': {
					backgroundColor: 'var(--neutral-bg-active)',
				},
				...rest.sx,
			}}
		>
			{children || (
				<LucideIcon
					icon={icon}
					size={16}
					color="inherit"
				/>
			)}
		</IconButton>
	);
}

export default NavbarToggleButton;
